import _ from 'underscore';
import React, { Component } from 'react';
import createReactClass from 'create-react-class';
import hoistNonReactStatic from 'hoist-non-react-statics';

function initalizeDispatcher(options$$1) {
  var _stores = {};
  var _sources = {};
  var _actions = {};
  var actionQueue = [];
  var actionCallbacks = {};
  var secondaryActionKeys = [];
  var storeCallbacks = {};
  var dispatcher$$1 = {
    isDispatching: false
  };

  var generateKey = function generateKey(name, collection, collection_type) {
    name = utils.camelize(name);
    var _key = name;
    var key_suffix = 0;

    while (collection[_key] != null) {
      _key = "" + name + key_suffix++;
    }

    if (_key !== name && process.env.NODE_ENV !== "test") {
      console.log("WARNING: multiple " + collection_type + " with same name: '" + name + "'");
    }

    return _key;
  };

  _.extend(dispatcher$$1, {
    registerActions: function registerActions(namespace, actions) {
      var _key = generateKey(namespace, _actions, "action namespaces");

      _actions[_key] = actions;
      return _key;
    },
    registerStore: function registerStore(name, privateStore) {
      var _key = generateKey(name, _stores, "stores");

      storeCallbacks[_key] = {
        callbacks: [],
        hasChanged: false
      };
      _stores[_key] = privateStore;
      return _key;
    },
    registerSource: function registerSource(name, privateSource) {
      var _key = generateKey(name, _sources, "sources");

      _sources[_key] = privateSource;
      return _key;
    },
    dispatchActions: function dispatchActions() {
      dispatcher$$1.isDispatching = true;

      try {
        while (actionQueue.length > 0) {
          if (_.size(secondaryActionKeys) > options$$1.max_secondary_actions) {
            if (typeof options$$1.onExceedMaxSecondaryActions === "function") {
              options$$1.onExceedMaxSecondaryActions(_.clone(secondaryActionKeys));
            }

            break;
          } else {
            var ref = actionQueue.shift();
            var key = ref.key;
            var args = ref.args;
            secondaryActionKeys.push(key);
            dispatcher$$1.dispatchAction(key, args);
          }
        }
      } finally {
        dispatcher$$1.isDispatching = false;
        secondaryActionKeys = [];
        actionQueue = [];
      }
    },
    dispatchAction: function dispatchAction(key, args) {
      _.each(storeCallbacks, function (store) {
        return store.hasChanged = false;
      });

      if (actionCallbacks[key] != null) {
        _.forEach(actionCallbacks[key], function (cb) {
          try {
            return cb.callback.apply(null, args);
          } finally {}
        });

        return _.forEach(storeCallbacks, function (store, storeKey) {
          if (store.hasChanged) {
            return _.forEach(store.callbacks, function (cb) {
              try {
                return cb.callback.call(null);
              } finally {}
            });
          }
        });
      }
    },
    enqueueAction: function enqueueAction(key) {
      var args = [],
          len = arguments.length - 1;

      while (len-- > 0) {
        args[len] = arguments[len + 1];
      }

      actionQueue.push({
        key: key,
        args: args
      });

      if (!dispatcher$$1.isDispatching) {
        return dispatcher$$1.dispatchActions();
      }
    },
    registerActionCallback: function registerActionCallback(actionKey, callback, storeName) {
      if (!actionCallbacks[actionKey]) {
        actionCallbacks[actionKey] = [];
      }

      return actionCallbacks[actionKey].push({
        storeName: storeName,
        callback: callback
      });
    },
    registerStoreLifecycleMethods: function registerStoreLifecycleMethods(storeKey, methods) {
      return _.extend(storeCallbacks[storeKey], methods);
    },
    registerStoreCallback: function registerStoreCallback(storeKey, callback, listenerName) {
      var store = storeCallbacks[storeKey];

      if (store != null) {
        store.callbacks.push({
          listenerName: listenerName,
          callback: callback
        });

        if (_.size(store.callbacks) === 1) {
          return typeof store.firstListenerDidMount === "function" ? store.firstListenerDidMount() : undefined;
        }
      } else {
        return console.log("'" + listenerName + "' attemtped to listen to a store that hasn't registered: '" + storeKey + "'");
      }
    },
    unregisterStoreCallback: function unregisterStoreCallback(storeKey, callback, listenerName) {
      var store = storeCallbacks[storeKey];

      if (store != null) {
        store.callbacks = _.reject(store.callbacks, function (cb) {
          return cb.callback === callback;
        });

        if (_.size(store.callbacks) === 0) {
          return typeof store.lastListenerWillUnmount === "function" ? store.lastListenerWillUnmount() : undefined;
        }
      } else {
        return console.log("'" + listenerName + "' attemtped to unregister a listener to a store that didn't exist: '" + storeKey + "'");
      }
    },
    hasListeners: function hasListeners(store_key) {
      return _.size(storeCallbacks[store_key] != null ? storeCallbacks[store_key].callbacks : undefined) > 0;
    },
    setChanged: function setChanged(storeKey) {
      return storeCallbacks[storeKey] != null ? storeCallbacks[storeKey].hasChanged = true : undefined;
    },
    manual_trigger: function manual_trigger(store_key) {
      _.forEach(storeCallbacks[store_key] != null ? storeCallbacks[store_key].callbacks : undefined, function (cb) {
        return cb.callback.call(null);
      });

      return undefined;
    },
    _actions: _actions,
    _stores: _stores,
    _sources: _sources,
    _actionCallbacks: actionCallbacks,
    _storeCallbacks: storeCallbacks,
    _actionQueue: actionQueue,
    _secondaryActionKeys: secondaryActionKeys
  });

  window._flux = {
    stores: _stores,
    sources: _sources,
    actions: _actions,
    dispatcher: dispatcher$$1,
    reports: {
      actions: function actions(query) {
        if (query == null) {
          query = "";
        }

        var regex = new RegExp(query);

        var report = _.reduce(actionCallbacks, function (report, info, key) {
          var storeNames = _.pluck(info, "storeName");

          if (regex.test(key) || _.any(storeNames, function (name) {
            return regex.test(name);
          })) {
            return utils.toObject(key, storeNames, report);
          } else {
            return report;
          }
        }, {});

        return console.table(report);
      },
      stores: function stores(query) {
        if (query == null) {
          query = "";
        }

        var regex = new RegExp(query);

        var report = _.reduce(storeCallbacks, function (report, store, key) {
          var listenerNames = _.pluck(store.callbacks, "listenerName");

          if (regex.test(key) || _.any(listenerNames, function (name) {
            return regex.test(name);
          })) {
            return utils.toObject(key, listenerNames, report);
          } else {
            return report;
          }
        }, {});

        return console.table(report);
      },
      unused_actions: function unused_actions() {
        var all_action_keys = _.flatten(_.map(_actions, function (action) {
          return _.pluck(action, "_key");
        }));

        var used_action_keys = _.keys(actionCallbacks);

        var unused = _.difference(all_action_keys, used_action_keys);

        return console.log("Unused Actions: \n\n", unused.join("\n\n"));
      }
    }
  };
  return dispatcher$$1;
}

var utils = {
  camelize: function camelize(s) {
    return s;
  },
  toObject: function toObject(key, value, obj) {
    if (obj == null) {
      obj = {};
    }

    if (key != null) {
      obj[key] = value;
    }

    return obj;
  }
};
var options = {
  max_secondary_actions: 50,
  onExceedMaxSecondaryActions: _.noop,
  onInvalidPromiseReturnValue: _.noop
};
var dispatcher = initalizeDispatcher(options);

var _test_reset = function _test_reset() {
  return dispatcher = initalizeDispatcher(options);
};

var setOptions = function setOptions(options) {
  return _.extend(options, options);
};

var KEY = "depracated_is_mounted";

var createClass = function createClass(name, options$$1) {
  name = utils.camelize(name);
  var componentDidMount = options$$1.componentDidMount;
  var componentWillUnmount = options$$1.componentWillUnmount;
  options$$1.displayName = name;
  options$$1[KEY] = false;

  options$$1.componentDidMount = function () {
    this[KEY] = true;

    if (componentDidMount) {
      componentDidMount.call(this);
    }

    return options$$1.componentWillUnmount = function () {
      this[KEY] = false;

      if (componentWillUnmount) {
        return componentWillUnmount.call(this);
      }
    };
  };

  if (_.isFunction(options$$1.registerStores)) {
    if (options$$1.mixins == null) {
      options$$1.mixins = [];
    }

    options$$1.on = function (store, keys_or_cb, cb) {
      var mixin = store.mixin;
      var callback = cb || keys_or_cb;

      var prop_keys = function () {
        if (_.isString(keys_or_cb)) {
          return [keys_or_cb];
        } else if (_.isArray(keys_or_cb)) {
          return keys_or_cb;
        }
      }();

      if (_.isFunction(mixin) && _.isFunction(callback)) {
        return options$$1.mixins.push(mixin(callback, name, prop_keys));
      } else {
        return console.log("Error registering '" + name + "' with store: ", store);
      }
    };

    options$$1.registerStores();
  }

  return createReactClass(options$$1);
};

var createComponent = function createComponent(name, options$$1) {
  return React.createFactory(createClass(name, options$$1));
};

function createActions(namespace, options$$1) {
  var actions = {};

  var _namespace = dispatcher.registerActions(namespace, actions);

  var createAction = function createAction(name, validator) {
    var action;

    var _key = _namespace + "_" + name;

    if (_.isFunction(validator)) {
      var _payloadIsValid = true;
      var _messages = [];
      var _context = {
        require: function require(expression, message) {
          if (!expression) {
            _payloadIsValid = false;
            return _messages.push(message);
          }
        }
      };

      action = function action() {
        var args = [],
            len = arguments.length;

        while (len--) {
          args[len] = arguments[len];
        }

        try {
          validator.apply(_context, args);
        } catch (error) {
          _payloadIsValid = false;

          _messages.push("An error was thrown during payload validation");

          _messages.push(error);
        }

        if (!_payloadIsValid) {
          console.warn("ERROR: action '" + _key + "' could not be dispatched");

          _.each(_messages, function (message) {
            return console.warn("--- " + message);
          });
        } else {
          dispatcher.enqueueAction.apply(dispatcher, [_key].concat(Array.from(args)));
        }

        _messages = [];
        _payloadIsValid = true;
        return undefined;
      };
    } else if (validator === true) {
      action = function action() {
        var args = [],
            len = arguments.length;

        while (len--) {
          args[len] = arguments[len];
        }

        dispatcher.enqueueAction.apply(dispatcher, [_key].concat(Array.from(args)));
        return undefined;
      };
    } else {
      throw new Error("Error defining action '" + _key + "', a validation function or 'true' is required");
    }

    action._key = _key;
    return action;
  };

  return _.extend(actions, _.mapObject(options$$1, function (validator, name) {
    return createAction(name, validator);
  }));
}

function createSource(name, options$$1) {
  var PrivateSource = {
    promise: {}
  };
  var PublicApi = {
    promise: {}
  };

  var checkKey = function checkKey(key) {
    if (!key || PrivateSource[key] != null || PublicApi[key] != null) {
      console.log(key + " on store '" + name + "' is a reserved key");
      return false;
    } else {
      return true;
    }
  };

  var checkFunction = function checkFunction(fxn, key) {
    if (_.isFunction(fxn)) {
      return true;
    } else {
      console.log("the value for key '" + key + "' in the source '" + name + "' was not a function");
      return false;
    }
  };

  var _key = dispatcher.registerSource(name, PrivateSource);

  PublicApi._key = PrivateSource._key = _key;
  PublicApi.actions = PrivateSource.actions = createActions(_key, options$$1.actions);

  _.each(options$$1.api, function (method, key) {
    if (checkKey(key) && checkFunction(method, key)) {
      return PrivateSource[key] = PublicApi[key] = function () {
        method.apply(PrivateSource, arguments);
        return undefined;
      };
    }
  });

  _.each(options$$1.promise, function (method, key) {
    return PublicApi.promise[key] = PrivateSource.promise[key] = function () {
      var return_value = method.apply(PrivateSource, arguments);

      if (return_value != null ? return_value.then : undefined) {
        return return_value;
      } else {
        var methodName = name + ".promise." + key;
        options$$1.onInvalidPromiseReturnValue(methodName);
        return new Promise(function (res, rej) {
          return rej(new Error(methodName + " did not return a promise"));
        });
      }
    };
  });

  _.each(_.omit(options$$1, ["actions", "api", "promise"]), function (method, key) {
    if (checkKey(key)) {
      return PrivateSource[key] = _.isFunction(method) ? method.bind(PrivateSource) : method;
    }
  });

  PrivateSource._PublicApi = PublicApi;

  if (_.isFunction(options$$1.initialize)) {
    options$$1.initialize.call(PrivateSource);
  }

  return PublicApi;
}

function createStore(name, options$$1) {
  var PrivateStore = {};
  var PublicApi = {};
  var LIFECYCLE_METHOD_NAMES = ["firstListenerDidMount", "lastListenerWillUnmount"];
  var RESERVED_KEYS = LIFECYCLE_METHOD_NAMES.concat("api", "registerActions", "getInitialState");

  var _key = dispatcher.registerStore(name, PrivateStore);

  var lifecycle_methods = _.mapObject(_.pick(options$$1, LIFECYCLE_METHOD_NAMES), function (method) {
    return method.bind(PrivateStore);
  });

  dispatcher.registerStoreLifecycleMethods(_key, lifecycle_methods);

  var _state = _.isFunction(options$$1.getInitialState) ? options$$1.getInitialState.call(null) : {};

  var checkKey = function checkKey(key) {
    if (!key || PrivateStore[key] != null || PublicApi[key] != null) {
      console.warn(key + " is a reserved key for Store '" + _key + "'");
      return false;
    } else {
      return true;
    }
  };

  var checkFunction = function checkFunction(fxn, key) {
    if (_.isFunction(fxn)) {
      return true;
    } else {
      console.warn("the value for key '" + key + "' in the store '" + _key + "' was not a function");
      return false;
    }
  };

  var _validateObject = function _validateObject(func_name, input) {
    if (_.isObject(input)) {
      return true;
    } else {
      console.warn(func_name + " expects object as argument, got " + typeof input);
      return false;
    }
  };

  var _checkDispatching = function _checkDispatching(operation) {
    if (dispatcher.isDispatching) {
      return true;
    } else {
      console.warn("Error in store " + _key + ", attempted to call '" + operation + "'' from outside of an action callback.  all store state operations should be called synchronously as the result of an action");
      return false;
    }
  };

  _.extend(PrivateStore, {
    _key: _key,
    state: _state,
    on: function on(action, callback) {
      if (action != null && action._key != null) {
        return dispatcher.registerActionCallback(action._key, callback.bind(PrivateStore), _key);
      } else if (process.env.NODE_ENV !== "test") {
        return console.warn("'" + _key + "' store attempted to register to an an invalid action");
      }
    },
    trigger: function trigger() {
      return dispatcher.setChanged(_key);
    },
    manual_trigger: function manual_trigger() {
      return dispatcher.manual_trigger(_key);
    },
    setState: function setState(object) {
      if (_checkDispatching("setState") && _validateObject("setState", object)) {
        _.extend(_state, object);

        return this.trigger();
      }
    },
    replaceState: function replaceState(object) {
      if (_checkDispatching("replaceState") && _validateObject("replaceState", object)) {
        _state = object;
        return this.trigger();
      }
    },
    mergeState: function mergeState(key, new_object) {
      if (_checkDispatching("mergeState") && _validateObject("mergeState", new_object)) {
        _.extend(_state[key], new_object);

        return this.trigger();
      }
    },
    silentlySetState: function silentlySetState(object) {
      if (_checkDispatching("silentlySetState") && _validateObject("setState", object)) {
        _.extend(_state, object);

        return true;
      }
    },
    getState: function getState(key) {
      if (key != null) {
        return _state[key];
      }
    },
    getAllState: function getAllState() {
      return _state;
    },
    hasListeners: function hasListeners() {
      return dispatcher.hasListeners(_key);
    }
  });

  _.extend(PublicApi, {
    _key: _key,
    bindToUpdates: function bindToUpdates(callback) {
      if (_.isFunction(callback)) {
        return dispatcher.registerStoreCallback(_key, callback, "Manual Store Listener");
      } else {
        return console.log("Store bindToUpdates requires function as callback", callback);
      }
    },
    unbind: function unbind(callback) {
      if (_.isFunction(callback)) {
        return dispatcher.unregisterStoreCallback(_key, callback, "Manual Store Listener");
      }
    },
    mixin: function mixin(getState, listenerName, propKeys) {
      var mixin_methods;

      if (listenerName == null) {
        listenerName = "Unknown Store Listener";
      }

      if (!_.isFunction(getState)) {
        console.log("'" + listenerName + "' did not supply a function to register for store '" + name + "'");
      } else {
        var store_key = utils.camelize(name);
        var callback_key = "_on" + store_key + "Change";
        var mounted_key = "_isMounted_" + store_key;
        mixin_methods = {
          componentDidMount: function componentDidMount() {
            this[mounted_key] = true;
            return dispatcher.registerStoreCallback(_key, this[callback_key], listenerName);
          },
          componentWillUnmount: function componentWillUnmount() {
            this[mounted_key] = false;
            return dispatcher.unregisterStoreCallback(_key, this[callback_key], listenerName);
          }
        };

        if (_.isArray(propKeys)) {
          if (getState.length === 0) {
            console.warn("'" + listenerName + "' callback (for props [" + propKeys.join(", ") + "]) must accept an argument");
          } else {
            mixin_methods[callback_key] = function () {
              if (this[mounted_key]) {
                return this.setState(getState(this.props));
              }
            };

            mixin_methods.getInitialState = function () {
              return getState(this.props);
            };

            mixin_methods.componentDidUpdate = function (prevProps) {
              var this$1 = this;

              if (_.any(propKeys, function (propKey) {
                return !_.isEqual(prevProps[propKey], this$1.props[propKey]);
              })) {
                if (this[mounted_key]) {
                  return this.setState(getState(this.props));
                }
              }
            };
          }
        } else {
          mixin_methods[callback_key] = function () {
            if (this[mounted_key]) {
              return this.setState(getState.call(this));
            }
          };

          mixin_methods.getInitialState = function () {
            return getState.call(this);
          };
        }
      }

      return mixin_methods;
    }
  });

  var private_methods = _.omit(options$$1, RESERVED_KEYS);

  _.each(private_methods, function (method, key) {
    if (checkKey(key) && checkFunction(method)) {
      return PrivateStore[key] = method.bind(PrivateStore);
    }
  });

  if (_.isFunction(options$$1.registerActions)) {
    options$$1.registerActions.call(PrivateStore);
  }

  _.each(options$$1.api, function (method, key) {
    if (checkKey(key) && checkFunction(method)) {
      return PrivateStore[key] = PublicApi[key] = method.bind(PrivateStore);
    }
  });

  delete PrivateStore.on;
  return PublicApi;
}

function connect(WrappedComponent, storesArr, mapStateToProps) {
  var HOC = function (Component$$1) {
    function HOC(props) {
      Component$$1.call(this, props);
      this.state = _.extend({}, mapStateToProps(this.props));
      this.handleChange = this.handleChange.bind(this);
    }

    if (Component$$1) HOC.__proto__ = Component$$1;
    HOC.prototype = Object.create(Component$$1 && Component$$1.prototype);
    HOC.prototype.constructor = HOC;

    HOC.prototype.componentDidMount = function componentDidMount() {
      var this$1 = this;
      storesArr.forEach(function (store) {
        return store.bindToUpdates(this$1.handleChange);
      });
    };

    HOC.prototype.componentWillUnmount = function componentWillUnmount() {
      var this$1 = this;
      storesArr.forEach(function (store) {
        return store.unbind(this$1.handleChange);
      });
    };

    HOC.prototype.handleChange = function handleChange() {
      this.setState(_.extend({}, mapStateToProps(this.props)));
    };

    HOC.prototype.render = function render() {
      return React.createElement(WrappedComponent, _.extend({}, this.props, this.state));
    };

    return HOC;
  }(Component);

  HOC.displayName = "Connected-" + getDisplayName(WrappedComponent);
  hoistNonReactStatic(HOC, WrappedComponent);
  return HOC;
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

var useFluxStore = function useFluxStore(store, mapStateToProps) {
  var ref = React.useState(mapStateToProps());
  var state = ref[0];
  var setState = ref[1];

  function handleChange() {
    setState(mapStateToProps());
  }

  React.useEffect(function () {
    store.bindToUpdates(handleChange);
    return function unbind() {
      store.unbind(handleChange);
    };
  }, []);
  return state;
};

export { setOptions, utils, dispatcher, options, _test_reset, createComponent, createClass, createActions, createSource, createStore, connect, useFluxStore };